// extracted by mini-css-extract-plugin
module.exports = {"sso_message":"SSOPage_sso_message__-wu6A","info_message":"SSOPage_info_message__3A7dw","maintenance_image":"SSOPage_maintenance_image__30qNx"};